import { useEffect, useState } from "react"
import {
  ArtBlocksProjectFeatureFacetMetadata,
  fetchArtBlocksProjectFeatureFacets,
} from "utils/artBlocksMetadataApi"
import { isArtBlocksChainId } from "utils/artBlocksUrls"

const useArtBlocksProjectFeatureFacets = (
  contractAddress: string,
  projectId: string,
  chainId?: number | string | null
) => {
  const [data, setData] = useState<ArtBlocksProjectFeatureFacetMetadata | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() => {
    if (!contractAddress || !projectId || !isArtBlocksChainId(chainId)) {
      setData(null)
      setLoading(false)
      return
    }

    let cancelled = false
    setLoading(true)
    setError(false)

    fetchArtBlocksProjectFeatureFacets({
      contractAddress,
      projectId,
      chainId: Number(chainId),
    })
      .then((facets) => {
        if (!cancelled) setData(facets)
      })
      .catch(() => {
        if (!cancelled) setError(true)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [chainId, contractAddress, projectId])

  return { data, loading, error }
}

export default useArtBlocksProjectFeatureFacets
